import { DecimalPipe } from '@angular/common';
import {
    Directive,
    ElementRef,
    OnInit,
    OnDestroy,
    HostListener,
    Input,
    Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Directive({
    selector: '[currencyFormat]',
})
export class CurrencyFormatDirective implements OnInit, OnDestroy {
    @Input('currencyFormat') currencyModel: number;
    private subscription: Subscription;

    constructor(
        private el: ElementRef,
        private ngControl: NgControl,
        private decimal: DecimalPipe,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        this.setupValueChanges();
        this.formatCurrency(); // Initial formatting
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    @HostListener('blur') onBlur() {
        this.formatCurrency(); // Format on blur
    }

    @HostListener('focus') onFocus() {
        this.removeFormatting(); // Remove formatting on focus
    }

    private setupValueChanges() {
        const control = this.ngControl.control;
        if (!control) return;

        this.subscription = control.valueChanges
            .pipe(
                map((value) => {
                    if (value === null || value === undefined) return '';

                    const parts = value.toString().split('.');
                    let integerPart = parts[0].replace(/,/g, '');
                    let decimalPart = parts[1] ? `.${parts[1]}` : '';

                    if (integerPart.length > 3) {
                        const lastThree = integerPart.slice(-3);
                        const otherNumbers = integerPart.slice(0, -3);
                        integerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
                    }

                    return integerPart + decimalPart;
                })
            )
            .subscribe((v) => this.renderer.setProperty(this.el.nativeElement, 'value', v));
    }

    private formatCurrency() {
        const control = this.ngControl.control;
        if (control && control.value !== null && control.value !== undefined) {
            const formattedValue = this.formatNumber(control.value);
            this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
        }
    }

    private formatNumber(value: any): string {
        const parts = value.toString().split('.');
        let integerPart = parts[0].replace(/,/g, '');
        let decimalPart = parts[1] ? `.${parts[1]}` : '';

        if (integerPart.length > 3) {
            const lastThree = integerPart.slice(-3);
            const otherNumbers = integerPart.slice(0, -3);
            integerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
        }

        return integerPart + decimalPart;
    }

    private removeFormatting() {
        const value = this.el.nativeElement.value.replace(/,/g, '');
        this.renderer.setProperty(this.el.nativeElement, 'value', value);
    }
}
